import { render, staticRenderFns } from "./PartnerInfo.vue?vue&type=template&id=2398af3e&scoped=true"
import script from "./PartnerInfo.vue?vue&type=script&lang=js"
export * from "./PartnerInfo.vue?vue&type=script&lang=js"
import style0 from "./PartnerInfo.vue?vue&type=style&index=0&id=2398af3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398af3e",
  null
  
)

export default component.exports